<template>
  <v-card>
    <v-card-title class="d-flex justify-space-between align-center py-2">
      <span class="text-h6">Mapeo de tipos de documento</span>
      <v-btn icon variant="text" @click="$emit('close')">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text class="pt-2">
      <v-alert type="info" variant="tonal" density="compact" class="mt-1 mb-2 py-1">
        Seleccione el tipo de documento del sistema para cada tipo de documento
        del financiador.
      </v-alert>
      <v-row>
        <v-col cols="12">
          <v-data-table
            :headers="headers"
            :items="rows"
            :loading="isLoading"
            :items-per-page="10"
            class="elevation-1"
          >
            <template #[`item.gecrosTipoDoc`]="{ item }">
              <div class="text-body-2">
                <div class="font-weight-medium">{{ item.gecrosNombre }}</div>
                <div class="text-caption text-medium-emphasis">
                  {{ item.gecrosCodigo }}
                </div>
              </div>
            </template>
            <template #[`item.tipoDocId`]="{ item }">
              <v-select
                density="compact"
                variant="outlined"
                :items="tiposDocumento"
                item-title="label"
                item-value="id"
                v-model="item.tipoDocId"
                :menu-props="{ maxHeight: 350 }"
                clearable
                hide-details
              />
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions class="justify-end">
      <v-btn color="primary" :loading="isSaving" variant="flat" @click="onSave" :disabled="isSaving || rows.length === 0"
        >Guardar</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "TiposDocMapeoModal",
  props: {
    financiadorId: { type: Number, required: true },
  },
  data() {
    return {
      isLoading: false,
      isSaving: false,
      rows: [],
      tiposDocumento: [],
      headers: [
        {
          title: "Tipo documento financiador (GECROS)",
          key: "gecrosTipoDoc",
          sortable: false,
        },
        {
          title: "Tipo documento RPFácil",
          key: "tipoDocId",
          sortable: false,
          align: "end",
        },
      ],
    };
  },
  created() {
    this.init();
  },
  methods: {
    ...mapActions({
      getTiposDocMapeoView: "financiador/getTiposDocMapeoView",
      saveTiposDocMapeo: "financiador/saveTiposDocMapeo",
      getTiposDocumentos: "taxonomy/getTiposDocumentos",
      setAlert: "user/setAlert",
    }),
    async init() {
      this.isLoading = true;
      try {
        const [vista, tipos] = await Promise.all([
          this.getTiposDocMapeoView(this.financiadorId),
          this.getTiposDocumentos(),
        ]);
        const mappedRows = (vista || []).map((v) => ({
          gecrosTipoDocId: v.gecrosTipoDocId,
          gecrosCodigo: v.gecrosCodigo,
          gecrosNombre: v.gecrosNombre,
          tipoDocId: v.tipoDocId ?? null,
        }));
        // Orden: primero los que tienen relación configurada (tipoDocId), luego por id descendente
        this.rows = mappedRows.sort((a, b) => {
          const aHas = a.tipoDocId ? 1 : 0;
          const bHas = b.tipoDocId ? 1 : 0;
          if (aHas !== bHas) return bHas - aHas; // mapeados primero
          return (a.gecrosTipoDocId ?? 0) - (b.gecrosTipoDocId ?? 0); // ascendente por ID
        });
        this.tiposDocumento = (tipos || []).map((t) => ({
          id: t.id,
          label: `${t.value1} - ${t.value2}`,
        }));
      } catch (e) {
        console.error("Error inicializando modal mapeo tipos doc", e);
      }
      this.isLoading = false;
    },
    async onSave() {
      try {
        this.isSaving = true;
        const payload = this.rows
          .filter((r) => r.tipoDocId)
          .map((r) => ({
            tipoDocId: r.tipoDocId,
            gecrosTipoDocId: r.gecrosTipoDocId,
          }));
        const res = await this.saveTiposDocMapeo({
          financiadorId: this.financiadorId,
          mappings: payload,
        });
        if (res?.status === 200) {
          this.setAlert({
            type: "success",
            message: "Configuración guardada correctamente",
          });
          this.$emit("saved");
        }
      } catch (e) {
        console.error("Error guardando mapeo tipos doc", e);
      } finally {
        this.isSaving = false;
      }
    },
  },
};
</script>

<style scoped></style>
